import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiPaths } from "../../api/paths";
import Loader from "../../components/loader/Loader";
import { useAppContext } from "../../context/app-context";
import useMutateData from "../../hooks/use-mutate-data";

export default function RegistrationRequest() {
  const { keycloakProfile } = useAppContext();
  const navigate = useNavigate();
  const { mutate } = useMutateData(ApiPaths.register, {
    method: "POST",
    onSuccess: () => {
      navigate("/sumsub");
    },
  });
  useEffect(() => {
    if (keycloakProfile) {
      mutate({
        ...keycloakProfile,
      });
    }
  }, [keycloakProfile]);

  return <Loader isFullScreen isLoading></Loader>;
}
